import React from 'react';
import styled from 'styled-components';

const Card = styled.div`
    border-radius: 0.625em;
    border-left: 8px solid rgba(195, 35, 64, 0.5);
    background-color: #ffffff;
    cursor: pointer
`

const H1 = styled.h1`
    font-size: 3em;
    margin: 0;
    font-weight: 400;
`

const H6 = styled.h6`
    font-size: 1.5em;
    color: rgba(0, 0, 0, 0.5);
`
const H7 = styled.h6`
    font-size: 1em;
    color: rgba(0, 0, 0, 0.5);
`
const StyledRightBarTop = styled.div`
  display: flex;
  justify-content: space-between;
`;
const OverviewCard = ({ title, subTitle,views,israting ,icon ,showRatingView}) => {
  return (
    <Card className='p-1 text-left shadow-lg overview-segment-card' onClick={()=> israting && showRatingView()}>
      <StyledRightBarTop>
        <H1>{title}</H1>
        {israting &&  <img src={icon} alt="Logo" />}
        </StyledRightBarTop>
        <H6>{subTitle}</H6>
        {israting && <H7>{views}</H7>}
    </Card>
  )
}

export default OverviewCard